import { LitElement, html } from "lit";
import { packageReviewsStyles } from "js/sharedStyles/packageReviews.js";

class WJPackageReviews extends LitElement {
  static properties = {
    providerRatings: {
      type: Object,
      attribute: "data-provider-ratings",
    },
    providerUrl: {
      type: String,
      attribute: "data-provider-url",
    },
  };
  static styles = [packageReviewsStyles];

  render() {
    const { providerRatings } = this;
    if (!providerRatings) return html``;

    const parsedOverallRating = Number.parseFloat(providerRatings.overallRating);
    const ratingStr = (parsedOverallRating * 2).toFixed(1).replace(".", ",");
    const [ratingInt, ratingDec] = ratingStr.split(",");
    const ratings = providerRatings.ratings ?? [];

    return html`
      <h5 class="mb-">Bewertungen</h5>

      <div class="layout layout--nowrap layout--flush">
        <div class="layout__item c-rating-wrapper">
          <div class="u-bg-color-grey--x-light u-border-radius-s ph pv- mb(s)">
            <div class="layout layout--middle layout--flush u-flex-wrap--nowrap mb--">
              <div class="layout__item">
                <div class="u-font-weight--bold">Durchschnittliche Bewertung<span class="c-icon-info"></span></div>
                <div class="u-size-s u-font-weight--bold u-text-color-grey">${providerRatings.numberOfRatings} Bewertungen</div>
              </div>
              <div class="layout__item u-1/4 u-text-align--center pv-">
                <span class="c-rating-total c-rating-total--tab c-spec c-spec--amount">
                  ${ratingInt}<span class="c-spec__decimals">,${ratingDec}</span>
                  <span class="c-rating-total__svg"
                    ><svg viewBox="0 0 61 61" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M28.195 58.036l-1.345.559a5.354 5.354 0 01-6.175-1.522l-.93-1.12a6 6 0 00-4.083-2.143l-1.45-.13a5.354 5.354 0 01-4.76-4.217l-.304-1.424a6 6 0 00-2.619-3.794l-1.224-.789A5.354 5.354 0 013.05 37.51l.393-1.401a6 6 0 00-.556-4.577l-.717-1.267a5.354 5.354 0 01.767-6.314l1-1.059a6 6 0 001.634-4.31l-.046-1.456a5.354 5.354 0 013.613-5.234l1.377-.473a6 6 0 003.451-3.057l.635-1.31a5.354 5.354 0 015.632-2.956l1.439.221a6 6 0 004.477-1.103l1.171-.865a5.354 5.354 0 016.36 0l1.171.865a6 6 0 004.477 1.103l1.44-.221a5.354 5.354 0 015.63 2.956l.636 1.31a6 6 0 003.45 3.057l1.378.473a5.354 5.354 0 013.613 5.234l-.046 1.455a6 6 0 001.635 4.311l1 1.059a5.354 5.354 0 01.766 6.314l-.717 1.267a6 6 0 00-.556 4.577l.393 1.401a5.354 5.354 0 01-2.255 5.947l-1.224.789a6 6 0 00-2.62 3.794l-.303 1.424a5.354 5.354 0 01-4.76 4.218l-1.45.13a6 6 0 00-4.083 2.142l-.93 1.12a5.354 5.354 0 01-6.175 1.522l-1.345-.56a6 6 0 00-4.61 0z"
                        fill="#61A38D"
                        class="u-svg-fill"
                      ></path>
                      <circle stroke="#F7F7F7" cx="30.5" cy="30.5" r="22" stroke-width="2"></circle></svg
                  ></span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="layout__item pl+(!s)">
          ${ratings.map(
            (rating, index) => html`
              <div class="${index === 0 ? "" : "u-border--top pt-"} pt-(s)">
                <div class="u-size-s"><strong class="mr-">${rating.header}</strong><span class="u-text-color-grey">${rating.lastModificationDate?.split("-").reverse().join(".")}</span></div>
                <div class="c-star-rating c-star-rating--small mb-">
                  <span class="c-star-rating__empty"></span>
                  <span class="c-star-rating__full" style="width: ${(rating.stars / 5) * 100}%"></span>
                </div>
                <div class="u-size-s mb-">${rating.text}</div>
              </div>
            `
          )}

          <!-- Check if providerUrl contains a path like /anbieter/xyz and if so, show link to all reviews -->
          <!-- TODO: Remove once BE has fixed the provider syncing issue and providerUrl always contains the correct path -->
          ${this.providerUrl && /\/anbieter\/[^/?#]+/.test(this.providerUrl)
            ? html`
                <div class="mb-">
                  <a href="${this.providerUrl}#bewertungen" class="c-link c-link--accent">Alle ${providerRatings.numberOfRatings} Bewertungen ansehen</a>
                </div>
              `
            : ""}
        </div>
      </div>
    `;
  }
}
const initWJPackageReviews = () => {
  window.customElements.define("wj-package-reviews", WJPackageReviews);
};

export { initWJPackageReviews };
